var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.83301 10.332C8.04063 10.332 6.58301 8.87441 6.58301 7.08203C6.58301 5.29047 8.04063 3.83203 9.83301 3.83203C11.6254 3.83203 13.083 5.29047 13.083 7.08203C13.083 8.87441 11.6254 10.332 9.83301 10.332ZM9.83301 5.45703C8.93682 5.45703 8.20801 6.18503 8.20801 7.08203C8.20801 7.97822 8.93682 8.70703 9.83301 8.70703C10.7292 8.70703 11.458 7.97822 11.458 7.08203C11.458 6.18503 10.7292 5.45703 9.83301 5.45703Z",
    fill: "#959595"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.333 16.832H3.33301V16.0195C3.33301 13.149 6.00613 11.1445 9.83301 11.1445C13.6599 11.1445 16.333 13.149 16.333 16.0195V16.832ZM5.0872 15.207H14.5796C14.0938 13.738 12.2778 12.7695 9.83382 12.7695C7.38982 12.7695 5.57307 13.738 5.0872 15.207Z",
    fill: "#959595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIcon);
export default __webpack_public_path__ + "static/media/PersonIcon.a4f1d62a52ab8005b228e7f209e55b55.svg";
export { ForwardRef as ReactComponent };